import React from 'react';
import NoData from 'components/_common/NoData';
import Loading from 'components/_common/Loading';
import PageUtil from 'utils/Page.util';
import { ReceptionItemKind, getReceptionStatus, getReceptionType, ReceptionType } from 'enums/reception.enum';
import { NavLink } from 'react-router-dom';

const DashboardV = ({
    params,
    goPage,
}) => {
    const {
        isLoaded,
        error,
        year,
        dashboardData
    } = params;

    // 편의상 변수 추출
    const kpi = dashboardData?.kpi || {};
    const exchangeInboundList = dashboardData?.exchangeInboundList || [];
    const tripInboundList = dashboardData?.tripInboundList || [];
    const arrearsList = dashboardData?.arrearsList || [];

    return (
        <>
            {isLoaded && error == null ? (
                <>
                    <div className="content-header">
                        <h1>
                            <span>대시보드</span>
                        </h1>
                    </div>

                    <div className="container-fluid">
                        {/* ===== KPI 섹션 시작 ===== */}
                        <div className="row mb-3">
                            <div className="col-12">
                                <div className="card card-outline card-primary">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            <i className="fas fa-chart-line mr-2"></i>
                                            {year}년 AS현황
                                        </h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            {/* ${year}년 견적금액 */}
                                            <div className="col-md-2 col-sm-6" style={{ cursor: 'pointer' }} onClick={() => goPage('/as-analytics')}>
                                                <div className="info-box bg-primary">
                                                    <span className="info-box-icon">
                                                        <i className="fas fa-dollar-sign"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text text-white">AS견적금액</span>
                                                        <span className="info-box-number text-white">
                                                            {PageUtil.formatToKRW(kpi.totalRevenue)}
                                                        </span>
                                                        <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                            <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                        </div>
                                                        <span className="progress-description text-white">
                                                            <small>{year}년 AS견적금액</small>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* 이익 */}
                                            <div className="col-md-2 col-sm-6" style={{ cursor: 'pointer' }} onClick={() => goPage('/as-analytics')}>
                                                <div className="info-box bg-success">
                                                    <span className="info-box-icon">
                                                        <i className="fas fa-chart-line"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text text-white">AS이익</span>
                                                        <span className="info-box-number text-white">
                                                            {PageUtil.formatToKRW(kpi.totalProfit)}
                                                        </span>
                                                        <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                            <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                        </div>
                                                        <span className="progress-description text-white">
                                                            <small>{year}년 AS이익</small>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* 비용 */}
                                            <div className="col-md-2 col-sm-6">
                                                <div className="info-box bg-warning">
                                                    <span className="info-box-icon">
                                                        <i className="fas fa-coins"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text text-white">AS비용</span>
                                                        <span className="info-box-number text-white">
                                                            {PageUtil.formatToKRW(kpi.totalCost)}
                                                        </span>
                                                        <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                            <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                        </div>
                                                        <span className="progress-description text-white">
                                                            <small>{year}년 AS비용</small>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* 미수금 */}
                                            <div className="col-md-2 col-sm-6" style={{ cursor: 'pointer' }} onClick={() => goPage('/estimate')}>
                                                <div className="info-box bg-danger">
                                                    <span className="info-box-icon">
                                                        <i className="fas fa-exclamation-triangle"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text text-white">AS미수금</span>
                                                        <span className="info-box-number text-white">
                                                            {PageUtil.formatToKRW(kpi.totalArrears)}
                                                        </span>
                                                        <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                            <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                        </div>
                                                        <span className="progress-description text-white">
                                                            <small>{year}년 AS미수금</small>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* 미수건수 */}
                                            <div className="col-md-2 col-sm-6" style={{ cursor: 'pointer' }} onClick={() => goPage('/estimate')}>
                                                <div className="info-box bg-info">
                                                    <span className="info-box-icon">
                                                        <i className="fas fa-clipboard-list"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text text-white">AS미수건수</span>
                                                        <span className="info-box-number text-white">
                                                            {kpi.arrearsCount?.toLocaleString() || 0}건
                                                        </span>
                                                        <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                            <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                        </div>
                                                        <span className="progress-description text-white">
                                                            <small>{year}년 AS 미수건수</small>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* 출장미완료 */}
                                            <div className="col-md-2 col-sm-6" style={{ cursor: 'pointer' }}>
                                                <div className="info-box bg-secondary">
                                                    <span className="info-box-icon">
                                                        <i className="fas fa-calendar-check"></i>
                                                    </span>
                                                    <div className="info-box-content">
                                                        <span className="info-box-text text-white">출장미완료</span>
                                                        <span className="info-box-number text-white">
                                                            {kpi.tripPending?.toLocaleString() || 0}건
                                                        </span>
                                                        <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                            <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                        </div>
                                                        <span className="progress-description text-white">
                                                            <small>{year}년 AS출장미완료건수</small>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* ===== KPI 섹션 끝 ===== */}

                        {/* 미입고 && 맞교환 */}
                        {/* <div className="card card-outline card-info mb-4">
                            <div className="card-header">
                                <div className="card-title">미입고(맞교환) - {exchangeInboundList.length}건</div>
                                <div className="card-tools">
                                    <span className="badge bg-info">
                                        {exchangeInboundList.length} 건
                                    </span>
                                </div>
                            </div>
                            <div className="card-body table-responsive p-0">
                                {exchangeInboundList.length === 0 ? (
                                    <NoData />
                                ) : (
                                    <table className="table text-nowrap">
                                        <thead>
                                            <tr>
                                                <th>처리상황</th>
                                                <th>접수일자</th>
                                                <th>처리유형</th>
                                                <th>고객명</th>
                                                <th>연락처</th>
                                                <th>보일러명</th>
                                                <th>제조년월</th>
                                                <th>접수내용</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {exchangeInboundList.map((row) => (
                                                <tr key={row.id}>
                                                    <td>
                                                        <span className="badge bg-warning">
                                                            {getReceptionStatus().find((s) => s.value === row.status)?.label || row.status}
                                                        </span>
                                                    </td>
                                                    <td style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                        {row.receivedDate || ''}
                                                    </td>
                                                    <td>
                                                        <span className={"badge " + (row.type == ReceptionType.NEW_EXCHANGE ? ' bg-danger' : 'bg-info')}>
                                                            {getReceptionType().find((t) => t.value === row.type)?.label || row.type}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <strong>{row.customerName || ''}</strong>
                                                    </td>
                                                    <td>
                                                        {row.phone1 || ''}
                                                    </td>
                                                    <td>
                                                        <code>{(row.items?.find(p => p.kind === ReceptionItemKind.BOILER)?.modelName || '') + (row.items?.filter(p => p.kind === ReceptionItemKind.BOILER)?.length > 1 ? ' 外' : '')}</code>
                                                    </td>
                                                    <td>
                                                        <small>{row?.items?.find(p => p.manufactureMonth)?.manufactureMonth || ''}</small>
                                                    </td>
                                                    <td>
                                                        <small>{row.requestNote && row.requestNote.length > 10
                                                            ? `${row.requestNote.substring(0, 10)}...`
                                                            : (row.requestNote || '')
                                                        }</small>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div> */}

                        {/* 미입고 && 출장 */}
                        {/* <div className="card card-outline card-secondary">
                            <div className="card-header">
                                <div className="card-title">미입고(출장) - {tripInboundList.length}건</div>
                                <div className="card-tools">
                                    <span className="badge bg-secondary">
                                        {tripInboundList.length} 건
                                    </span>
                                </div>
                            </div>
                            <div className="card-body table-responsive p-0">
                                {tripInboundList.length === 0 ? (
                                    <NoData />
                                ) : (
                                    <table className="table text-nowrap">
                                        <thead>
                                            <tr>
                                                <th>처리상황</th>
                                                <th>접수일자</th>
                                                <th>처리유형</th>
                                                <th>고객명</th>
                                                <th>연락처</th>
                                                <th>보일러명</th>
                                                <th>제조년월</th>
                                                <th>접수내용</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tripInboundList.map((row) => (
                                                <tr key={row.id}>
                                                    <td>
                                                        <span className="badge bg-warning">
                                                            {getReceptionStatus().find((s) => s.value === row.status)?.label || row.status}
                                                        </span>
                                                    </td>
                                                    <td style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                        {row.receivedDate || ''}
                                                    </td>
                                                    <td>
                                                        <span className={"badge " + (row.type == ReceptionType.NEW_EXCHANGE ? ' bg-danger' : 'bg-info')}>
                                                            {getReceptionType().find((t) => t.value === row.type)?.label || row.type}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <strong>{row.customerName || ''}</strong>
                                                    </td>
                                                    <td>
                                                        {row.phone1 || ''}
                                                    </td>
                                                    <td>
                                                        <code>{(row.items?.find(p => p.kind === ReceptionItemKind.BOILER)?.modelName || '') + (row.items?.filter(p => p.kind === ReceptionItemKind.BOILER)?.length > 1 ? ' 外' : '')}</code>
                                                    </td>
                                                    <td>
                                                        <small>{row?.items?.find(p => p.manufactureMonth)?.manufactureMonth || ''}</small>
                                                    </td>
                                                    <td>
                                                        <small>{row.requestNote && row.requestNote.length > 10
                                                            ? `${row.requestNote.substring(0, 10)}...`
                                                            : (row.requestNote || '')
                                                        }</small>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div> */}

                        {/* AS 미수 */}
                        {/* <div className="card card-outline card-warning">
                            <div className="card-header">
                                <div className="card-title">AS 미수 - {arrearsList.length}건</div>
                                <div className="card-tools">
                                    <span className="badge bg-warning">
                                        {arrearsList.length} 건
                                    </span>
                                </div>
                            </div>
                            <div className="card-body table-responsive p-0">
                                {arrearsList.length === 0 ? (
                                    <NoData />
                                ) : (
                                    <table className="table text-nowrap">
                                        <thead>
                                            <tr>
                                                <th>처리상황</th>
                                                <th>접수일자</th>
                                                <th>처리유형</th>
                                                <th>고객명</th>
                                                <th>연락처</th>
                                                <th>보일러명</th>
                                                <th>제조년월</th>
                                                <th>접수내용</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {arrearsList.map((row) => (
                                                <tr key={row.id}>
                                                    <td>
                                                        <span className="badge bg-warning">
                                                            {getReceptionStatus().find((s) => s.value === row.status)?.label || row.status}
                                                        </span>
                                                    </td>
                                                    <td style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                        {row.receivedDate || ''}
                                                    </td>
                                                    <td>
                                                        <span className={"badge " + (row.type == ReceptionType.NEW_EXCHANGE ? ' bg-danger' : 'bg-info')}>
                                                            {getReceptionType().find((t) => t.value === row.type)?.label || row.type}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <strong>{row.customerName || ''}</strong>
                                                    </td>
                                                    <td>
                                                        {row.phone1 || ''}
                                                    </td>
                                                    <td>
                                                        <code>{(row.items?.find(p => p.kind === ReceptionItemKind.BOILER)?.modelName || '') + (row.items?.filter(p => p.kind === ReceptionItemKind.BOILER)?.length > 1 ? ' 外' : '')}</code>
                                                    </td>
                                                    <td>
                                                        <small>{row?.items?.find(p => p.manufactureMonth)?.manufactureMonth || ''}</small>
                                                    </td>
                                                    <td>
                                                        <small>{row.requestNote && row.requestNote.length > 10
                                                            ? `${row.requestNote.substring(0, 10)}...`
                                                            : (row.requestNote || '')
                                                        }</small>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div> */}
                    </div>
                </>
            ) : (
                <Loading />
            )}
        </>
    );
};

export default DashboardV;